import { render } from "./AdminDatesPage.vue?vue&type=template&id=2a1ead30&scoped=true"
import script from "./AdminDatesPage.vue?vue&type=script&lang=js"
export * from "./AdminDatesPage.vue?vue&type=script&lang=js"

import "./AdminDatesPage.vue?vue&type=style&index=0&id=2a1ead30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1ead30"]])

export default __exports__